import React from "react";
import {Text} from "@renta-apps/renta-react-components";
import styles from "./EquipmentsGrid.module.scss";

interface ExpandedInfoFieldProps {
    label: string;
    value: string | number | null;
    dataCy: string;
}

const ExpandedInfoField: React.FC<ExpandedInfoFieldProps> = ({label, value, dataCy}) => {
    return (
        <div className={styles.expandedInfoField}>
            <Text tag={"label"} size={"Normal"} weight="medium">
                {label}
            </Text>
            <span className={styles.ellipsisText} data-cy={dataCy}>
                {value !== null ? value : "-"}
            </span>
        </div>
    );
};

export default ExpandedInfoField;